import styled from "styled-components";
import {
  PRIMARY_COLOR,
  BOLD_FONT,
  SEMI_BOLD_FONT,
  QUERY_IPAD,
  QUERY_IPHONE_6_7_8_PLUS,
} from "@shared/constants";

export const StyledSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 150px 32px;

  .content {
    max-width: 700px;
  }

  .container {
    background-color: #ffffff;
    padding: 52px 50px;
    border-radius: 24px;
    display: flex;
  }

  .info {
    margin-right: 40px;
    .tabs {
      margin-bottom: 40px;

      span {
        position: relative;
        font-size: 16px;
        font-weight: ${BOLD_FONT};
        color: ${PRIMARY_COLOR};
        z-index: 1;
        cursor: pointer;
        transition: color 0.3s;

        &:not(:last-child) {
          margin-right: 48px;
        }

        &.selected {
          color: #ffffff;
        }

        &.selected::after {
          content: "";
          position: absolute;
          top: -8px;
          bottom: -8px;
          left: -16px;
          right: -16px;
          z-index: -1;
          background-color: ${PRIMARY_COLOR};
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.25);
          border: 2px solid #ffffff;
          border-radius: 100px;
          animation: fadein 0.5s;
        }

        &:hover:not(.selected) {
          color: ${PRIMARY_COLOR};
        }
      }
    }

    .tab-content {
      animation: fadein 0.5s;
    }

    .position {
      &:not(:last-child) {
        margin-bottom: 12px;
      }

      .title {
        font-size: 18px;
        font-weight: ${SEMI_BOLD_FONT};

        a {
          position: relative;
          text-decoration: none;
          white-space: nowrap;

          &:after {
            content: "";
            display: block;
            bottom: -3px;
            height: 2px;
            left: 50%;
            position: absolute;
            background: ${PRIMARY_COLOR};
            transition: width 0.3s ease 0s, left 0.3s ease 0s;
            width: 0;
          }

          &:hover:after {
            width: 100%;
            left: 0;
          }
        }
      }

      .date {
        font-size: 13px;
        color: ${PRIMARY_COLOR};
        font-style: italic;
      }
    }

    .tech-keypoints {
      list-style-type: none;
      margin-top: 38px;

      li {
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 24px;
        padding-left: 16px;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          top: 8px;
          left: 0;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: ${PRIMARY_COLOR};
        }
      }
    }
  }

  .hidden {
    display: none !important;
  }

  @media (max-width: ${QUERY_IPAD}px) {
    .container {
      flex-direction: column;
      padding: 42px 30px;
    }
  }

  @media (max-width: ${QUERY_IPHONE_6_7_8_PLUS}px) {
    padding: 100px 24px;

    .container {
      padding: 42px 26px;
    }
  }


  /**
   * ANIMATIONS
   */
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
